module.exports = __webpack_public_path__ + "static/media/discount.90bb5ed2.svg";